<template>
  <div :style="{ width: '100%', height: '100%', borderRadius: '4px' }">
    <a-calendar v-model:value="value" :fullscreen="true"  @select="handleSelect" @dblclick="handleDbClick">
      <template #dateCellRender="{ current: dayjs }">
        <div v-if="haveMsg(dayjs)" class="haveDate">
          <check-outlined />
        </div>
      </template>
    </a-calendar>
  </div>
  <div class="footer-box" >
      <a-button type="primary" @click="handleSubmit" :loading="saveLoading">保存</a-button>
      <a-button type="primary" @click="handleResetDate" :loading="resetLoading" style="margin-left:10px">初始化休息日</a-button>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref, watch, onMounted } from 'vue'
import dayjs, { Dayjs } from 'dayjs'
import { CheckOutlined } from '@ant-design/icons-vue'
import { getDayOffList, resetDayOff, saveDayOff } from '@/api/gucangSales/dayOffCalendar'
import { DcMessage } from '@dc-platform/dc-components'

export default defineComponent({
  components: {
    CheckOutlined
  },
  props: {
    typePage: {
      type: String,
      default: 'cos_fbu'
    }
  },
  setup(props) {
    const appidType = ref()
    watch(props, () => {
      appidType.value = props.typePage
      console.log('appidType.value: ', appidType.value)
    }, { immediate: true })
    const value = ref()
    const firstDay = ref()
    const lastDay = ref()
    const dayOffArr = ref<any>([])
    const data = ref<string>('')
    const monthData = ref()
    const getDayoffList = async() => {
      try {
        const res = await getDayOffList({
          appId: appidType.value,
          startTime: firstDay.value,
          endTime: lastDay.value
        })
        dayOffArr.value = res.data ? res.data : []
      } catch (error) {
        console.log('error: ', error)
      }
    }
    const haveMsg = (str: string) => {
      const data = dayjs(str).format('YYYY/MM/DD')
      if (dayOffArr.value) {
        const index = dayOffArr.value.findIndex((item:any) => {
          return item === data
        })
        if (index === -1) {
          return false
        } else {
          return true
        }
      }
    }
    const saveLoading = ref(false)
    const handleSubmit = async() => {
      try {
        saveLoading.value = true

        await saveDayOff({
          appId: appidType.value,
          startTime: firstDay.value,
          endTime: lastDay.value,
          dateValue: dayOffArr.value
        })
        DcMessage.success('保存成功！')
        saveLoading.value = false
      } catch (error) {
        saveLoading.value = false

        console.log('handleSubmiterror: ', error)
      }
    }
    const handleSelect = (day:Dayjs|string) => {
      if (typeof (day) !== 'string') {
        data.value = dayjs(day).format('YYYY/MM/DD')
      }
    }
    const resetLoading = ref(false)
    const handleDbClick = () => {
      const index = dayOffArr.value.findIndex((item:any) => {
        return item === data.value
      })
      if (index === -1) {
        dayOffArr.value.push(data.value)
      } else {
        dayOffArr.value.splice(index, 1)
      }
    }
    const handleResetDate = async() => {
      try {
        resetLoading.value = true
        const res = await resetDayOff({
          appId: appidType.value,
          startTime: firstDay.value,
          endTime: lastDay.value
        })
        dayOffArr.value = res.data ? res.data : []
        DcMessage.success('重置成功！')
        resetLoading.value = false
      } catch (error) {
        resetLoading.value = false
        console.log('handleResetDate error: ', error)
      }
    }
    watch(value, (newValue:Dayjs) => {
      firstDay.value = dayjs(newValue).startOf('month').format('YYYY/MM/DD')
      lastDay.value = dayjs(newValue).endOf('month').format('YYYY/MM/DD')
      monthData.value = dayjs(value.value).month()
    }, { immediate: true })
    watch(monthData, () => {
      getDayoffList()
    }, { immediate: true })
    onMounted(() => {
      getDayoffList()
    })
    return {
      value,
      haveMsg,
      handleSelect,
      dayOffArr,
      handleDbClick,
      handleSubmit,
      handleResetDate,
      resetLoading,
      saveLoading
    }
  }
})
</script>
<style lang="scss" scoped>
:deep(.ant-picker-cell-selected .ant-picker-calendar-date){
      background: #f5f5f5!important;

}
.haveDate{
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff6d1;
  width: 100%;
  height: 100%;
}
  .footer-box {
    width: 100%;
    height: 64px;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
